import { Injectable } from '@angular/core';

@Injectable()
export class StreamingAuthService {
    private email: string = 'streaming_user@example.com';

    setUserEmail(email: string): void {
        this.email = email;
    }

    getUserEmail(): string {
        return this.email;
    }
}
